import React from "react";

const Background = () => {
  return (
    <>
      <div className="background">
        <div className="linearbox1"></div>
        <div className="linearbox2"></div>
      </div>
    </>
  );
};

export default Background;